import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-badge.tsx
var LazyBadge = lazy(() => import("./badge-Bf7zUnX2.js").then((n) => n.n).then((module) => ({ default: module.Badge })));
function Badge({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "badge" }),
		children: /* @__PURE__ */ jsx(LazyBadge, { ...props })
	});
}
function BadgeContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "badge" }),
		children: /* @__PURE__ */ jsx(LazyBadge, { ...props })
	});
}
var useBadgeContent = () => {
	return useMemo(() => ({ badge: { component: BadgeContent } }), []);
};
//#endregion
export { Badge, useBadgeContent };
